// Tickets Tab Component
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Ticket } from 'lucide-react';

export const TicketsTab = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-2">
        <Ticket size={18} className="text-primary" />
        <Label className="text-base font-semibold">Biglietti</Label>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>URL Acquisto</Label>
          <Input
            value={formData.ticket_url}
            onChange={(e) => setFormData({ ...formData, ticket_url: e.target.value })}
            placeholder="https://eventbrite.com/..."
            className="bg-white/5 border-white/10"
          />
        </div>
        <div className="space-y-2">
          <Label>Prezzo</Label>
          <Input
            value={formData.ticket_price}
            onChange={(e) => setFormData({ ...formData, ticket_price: e.target.value })}
            placeholder="€49"
            className="bg-white/5 border-white/10"
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label>Testo Bottone (opzionale)</Label>
        <Input
          value={formData.ticket_label}
          onChange={(e) => setFormData({ ...formData, ticket_label: e.target.value })}
          placeholder="Acquista Biglietto"
          className="bg-white/5 border-white/10"
        />
      </div>
    </div>
  );
};
